export default __webpack_public_path__ + "static/media/Dashboard_main.c4e9eba9.png";